import script from "./TranscriptMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TranscriptMessage.vue?vue&type=script&setup=true&lang=ts"

import "./TranscriptMessage.vue?vue&type=style&index=0&id=91766c46&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91766c46"]])

export default __exports__